import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { maskWeekOf, maskWeek } from '../../masks';

class WeeklyMenus extends React.Component {
  render() {
    const weeks = this.genWeeks();
    const { menus = [] } = this.props;
    return (
      <div className="cms__section">
        <div className="cms__bar cms__section-head">
          <div className="cms__bar-left">
            <h3 className="h3">Weekly Menus</h3>
          </div>
          <div className="cms__bar-right">
            <Link to="/admin/menus" className="a--blue" data-cy="view-menus">
              View Menus
            </Link>
          </div>
        </div>
        <div className="cms__section-body cms__section-body--no-pad">
          <div className="week-blocks">
            {weeks.map((week, i) => (
              <MenuBlock
                key={i}
                index={i}
                week={week}
                menu={menus.find(m => m && m.service_week === week)}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }

  genWeeks = () => {
    const start = moment().startOf('week');
    return Array.from(Array(4).keys()).map(i =>
      start
        .clone()
        .add(i, 'weeks')
        .format('YYYY-MM-DD')
    );
  };
}
export default WeeklyMenus;

const MenuBlock = ({ week, menu = {}, index }) => {
  const { name = 'n/a', id = 0 } = menu;
  const nameClasses = ['week-block__name'];
  if (name === 'n/a') nameClasses.push('week-block__name--red');

  return (
    <div className="week-block">
      <div className="week-block__week">{dateSwitch(index, week)}</div>
      <div className={nameClasses.join(' ')}>{name}</div>
      <div className="week-block__date">{maskWeek(week)}</div>
      <div className="week-block__link">
        {id > 0 ? (
          <Link to={`/admin/menu/${id}`} className="a--blue">
            View
          </Link>
        ) : (
          <Link to={`/admin/menus`} className="a--blue">
            Create
          </Link>
        )}
      </div>
    </div>
  );
};

const dateSwitch = (index, week) =>
  ({
    0: 'This Week',
    1: 'Next Week'
  }[index] || maskWeekOf(week));



// WEBPACK FOOTER //
// ./src/components/dashboard/WeeklyMenus.js